<template>
  <div>
    <inline-field-actions :schema="schema"></inline-field-actions>
    <dropzone
      :key="schema.model"
      :id="schema.model"
      :ref="schema.model"
      :options="dropzoneOptions"
      v-on:vdropzone-success="setValue"
      v-on:vdropzone-removed-file="removeFile"
      v-on:vdropzone-error="handleError">
    </dropzone>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { abstractField } from 'vue-form-generator';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  mixins: [abstractField],

  components: { Dropzone },

  computed: {
    ...mapState({
      sessionId: state => state.user.sessionId,
    }),

    dropzoneOptions() {
      return {
        url: `${process.env.API_HOST}/uploads`,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        maxFilesize: 100,
        acceptedFiles: this.schema.acceptedFileTypes,
        addRemoveLinks: true,
        headers: { Authorization: this.sessionId },
        error(file, response) {
          this.defaultOptions.error(file, response.errors[0]);
        },
      };
    },
  },

  methods: {
    setValue(file, response) {
      if (!Array.isArray(this.value)) {
        this.value = [];
      }
      file.apiUUID = response.upload.uuid;
      this.value.push(response.upload.uuid);
      this.$parent.clearValidationErrors();
    },

    removeFile(file) {
      this.value = this.value.filter(val => val !== file.apiUUID);
    },

    handleError(file) {
      if (file.xhr) {
        const response = JSON.parse(file.xhr.response);
        this.$store.dispatch('handleError', {
          response,
        });
      }
    },
  },
};
</script>
